import { z } from 'zod';

export const ERROR_CODES = [
  'invalid_request',
  'invalid_code',
  'reauthentication_required',
  'no_access',
  'no_free_place',
  'group_locked',
  'account_exists',
  'already_covered',
  'price_changed',
  'unauthorized',
  'forbidden',
  'not_found',
  'conflict',
  'rate_limited',
  'unsupported_media_type',
  'payload_too_large',
  'service_unavailable',
  'internal_error',
] as const;

export type ErrorCode = (typeof ERROR_CODES)[number];

export const errorResponseSchema = z.object({
  error: z.object({
    code: z.enum(ERROR_CODES),
    message: z.string(),
    details: z.unknown().optional(),
  }),
});

export type ErrorResponse = z.infer<typeof errorResponseSchema>;
